<template>
    <button @click="$emit('btnClick')" :class="classes">{{placeholder}}</button>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'portal-btn',
    },
    classes: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped>
button{
  outline: none;
}
</style>
